
<v-data-table
  :headers="HEADERS"
  :items="data || []"
  :hide-default-footer="true"
  :dense="true"
  class="pod_rde_state_table"
  disable-pagination
/>
